import { GetMaxDateProps, GetMinDateProps } from 'types/components';

import dayjs from 'dayjs';

export const getMaxDate = ({ watchedMaxDate, maxDate }: GetMaxDateProps) =>
    watchedMaxDate
        ? dayjs(watchedMaxDate).subtract(1, 'day').endOf('day')
        : maxDate
        ? dayjs(maxDate).endOf('day')
        : undefined;

export const getMinDate = ({ watchedMinDate, minDate }: GetMinDateProps) =>
    watchedMinDate
        ? dayjs(watchedMinDate).add(1, 'day').startOf('day')
        : minDate
        ? dayjs(minDate).startOf('day')
        : undefined;

export const emailPattern =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const patternRule = (pattern, message) => ({
    pattern: {
        value: pattern,
        message: message,
    },
});
